import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import ReactResizeDetector from 'react-resize-detector';
import { withRouter, Switch, Route } from 'react-router-dom';
import ProgressBar from '../../../../components/progress-bar';
import piPermissions from '../../../../components/pi-permission';
import UserTable from '../../../Setup/components/UserTable/UserTable';
import WindowResizeListener from '../../../../components/window-size-listener';


// Import Actions
import { fetchAllPIUsers } from '../../AdminActions';

// Import Selectors
import { getPIUsers } from '../../AdminReducer';
import { getUser } from '../../../Auth/AuthReducer';
import PIUserDetailPage from '../PIUserDetailPage/PIUserDetailPage';

class PIUserPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: null,
      containerWidth: 0,
    };
    this.onWindowResize = this.onWindowResize.bind(this);
    this.onResizeContainer = this.onResizeContainer.bind(this);
    this.syncUsers = this.syncUsers.bind(this);
    this.handlePageSelect = this.handlePageSelect.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
  }

  componentDidMount() {
    const { location } = this.props;
    const query = queryString.parse(location.search);

    const page = query.page || 1;
    this.syncUsers(page);
  }

  onWindowResize() {
    if (this.container) {
      this.setState({ containerWidth: this.container.offsetWidth });
    }
  }
  onResizeContainer() {
    this.onWindowResize();
  }

  syncUsers(params) {
    return this.props.dispatch(fetchAllPIUsers(params));
  }

  handlePageSelect(page) {
    const { location } = this.props;
    const { pathname } = location;
    const query = queryString.parse(location.search);
    this.context.router.history.push({ pathname, query });
    this.syncUsers(page);
  }

  handleDelete(user) {
    const { location } = this.props;
    if (location.pathname !== '/admin/pi-users' && user._id === this.props.match.params.userID) {
      // redirect
      this.context.router.history.push('/admin/pi-users');
    }
    this.handlePageSelect(1);
  }
  handleUpdate(user) {
    if (user.role !== 'pi') {
      this.handlePageSelect(1);
    }
  }

  handleAdd(user) {
    if (user.role === 'pi') {
      this.context.router.history.push(`/admin/pi-users/${user._id}`);
      this.handlePageSelect(1);
    }
  }

  render() {
    const {
      loading, error, containerWidth,
    } = this.state;
    const { location, loginUser } = this.props;
    const isIndexPage = location.pathname === '/admin/pi-users';
    const cls = isIndexPage ? 'col-xs-12' : 'col-md-9';
    const subCls = isIndexPage ? 'col-xs-12' : 'col-md-3 animated bounceInRight';
    return (
      <div>
        <Helmet title="Manage PI Users" />
        <WindowResizeListener onResize={this.onWindowResize} />
        <p />
        <div className="container">
          <div className="row">
            <div className={cls}>
              <div ref={(el) => { this.container = el; }}>
                <ReactResizeDetector handleWidth onResize={this.onResizeContainer} />
                {loading && <ProgressBar />}
                {!loading && error === null &&
                  <div>
                    <UserTable
                      detailUrl="/admin/pi-users/"
                      width={containerWidth}
                      showOrganizationDetailColumn={false}
                      showEmailColumn={false}
                      onDelete={this.handleDelete}
                      onUpdate={this.handleUpdate}
                      organization={loginUser.organization}
                      onAdd={this.handleAdd}
                      fetchAction={this.syncUsers}
                      newUser={{ role: 'pi', invite: true, organization_role: 'manager' }}
                      disableDownload // not organization agnostic
                    />
                  </div>
                }
              </div>
            </div>
            <div className={subCls}>
              <Switch>
                <Route path="/admin/pi-users/:userID" component={PIUserDetailPage} />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// SetupPage.need = [() => { return fetchStages(); }];

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    loginUser: getUser(state),
    users: getPIUsers(state),
  };
}

PIUserPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({}).isRequired,
  users: PropTypes.shape({
    items: PropTypes.array.isRequired,
    meta: PropTypes.object.isRequired,
  }).isRequired,
  loginUser: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.object,
  }).isRequired,
};

PIUserPage.contextTypes = {
  router: PropTypes.object,
};

export default withRouter(connect(mapStateToProps)(piPermissions(PIUserPage, 'superadmin', 'admin')));
